export default __webpack_public_path__ + "static/Vlog-f4bc9e2375b5daf8f2c0d431ba929db5.svg";